import { MoonOutlined, SunOutlined } from "@ant-design/icons";

function ThemeToggle({ isDark, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-ink-200 bg-white text-ink-600 transition-colors hover:border-brand-300 hover:text-brand-600 dark:border-ink-700 dark:bg-ink-800 dark:text-ink-300 dark:hover:border-brand-500 dark:hover:text-brand-400"
    >
      {isDark ? <SunOutlined className="text-base" /> : <MoonOutlined className="text-base" />}
    </button>
  );
}

export default ThemeToggle;
